export default __webpack_public_path__ + "static/media/blank.2eb71060.jpg";